import { MODIFY_USER_PREFERENCE_SUCCESS, MODIFY_USER_PREFERENCE_FAIL } from '../constants/ActionTypes';

export default function modifyUserPreferencesSuccess(state = false, { type }) {
    switch (type) {
        case MODIFY_USER_PREFERENCE_FAIL:
            return false;

        case MODIFY_USER_PREFERENCE_SUCCESS:
            return true;

        default:
            return state;
    }
}
